import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCrN2iyG2HypxFpIjP9L0L6bwihQls_N78",
  authDomain: "escape-dece6.firebaseapp.com",
  projectId: "escape-dece6",
  storageBucket: "escape-dece6.firebasestorage.app",
  messagingSenderId: "216429901680",
  appId: "1:216429901680:web:bc64e8307a5fdce93141b5"
};

let app;
let auth;
let db;

try {
  // Initialize Firebase app
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
  
  // Initialize Auth
  auth = getAuth(app);
  
  // Initialize Firestore
  try {
    db = initializeFirestore(app, {
      cacheSizeBytes: CACHE_SIZE_UNLIMITED,
    });
    console.log('Firestore initialized successfully');
  } catch (firestoreError) {
    console.warn('Enhanced Firestore init failed, using basic:', firestoreError.message);
    db = getFirestore(app);
  }
  
  console.log('Firebase services initialized successfully');

} catch (error) {
  console.error('Firebase initialization error:', error);
}

// Network connectivity test
export const testNetworkConnectivity = async () => {
  try {
    const response = await fetch('https://www.google.com', { 
      method: 'HEAD',
      signal: AbortSignal.timeout(5000)
    });
    return response.ok;
  } catch (error) {
    console.log('Network test failed:', error.message);
    return false;
  }
};

// Firebase-specific connectivity test
export const testFirebaseConnectivity = async () => {
  try {
    const response = await fetch(`https://${firebaseConfig.projectId}-default-rtdb.firebaseio.com/.json`, {
      method: 'HEAD',
      signal: AbortSignal.timeout(5000)
    });
    return response.ok;
  } catch (error) {
    console.log('Firebase connectivity test failed:', error.message);
    return false;
  }
};

export { auth, db };
export default app;
